if (!customElements.get('card-bleed')) {
  class CardBleed extends HTMLElement {
    constructor() {
      super();

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.itemsContainer = this.querySelector('.card-bleed__items');

      /** @type {NodeListOf<HTMLElement>} */
      this.items = this.itemsContainer.querySelectorAll('.card-bleed__item');

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.prevButton = this.querySelector('[data-prev]');

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.nextButton = this.querySelector('[data-next]');

      this.prevButton.addEventListener('click', this.onPrev.bind(this));
      this.nextButton.addEventListener('click', this.onNext.bind(this));
    }

    connectedCallback() {
      window.addEventListener('resize', this.updateArrows.bind(this));
      this.updateArrows();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateArrows.bind(this));
    }

    onPrev() {
      const firstItem = this.items[0];
      const rect = firstItem.getBoundingClientRect();
      const cardWidth = rect.width;

      if (this.itemsContainer.scrollLeft === 0) {
        this.itemsContainer.scrollLeft = this.itemsContainer.scrollWidth;
        return;
      }

      this.itemsContainer.scrollLeft =
        this.itemsContainer.scrollLeft - cardWidth;
    }

    onNext() {
      const lastItem = this.items[this.items.length - 1];
      const rect = lastItem.getBoundingClientRect();
      const cardWidth = rect.width;
      const rightEdge = rect.x + cardWidth;

      if (rightEdge > document.body.clientWidth) {
        this.itemsContainer.scrollLeft =
          this.itemsContainer.scrollLeft + cardWidth;
        return;
      }

      this.itemsContainer.scrollLeft = 0;
    }

    updateArrows() {
      if (
        this.itemsContainer.clientWidth <
        this.itemsContainer.scrollWidth - 30
      ) {
        this.setAttribute('data-has-arrows', '');
      } else {
        this.removeAttribute('data-has-arrows');
      }
    }
  }

  customElements.define('card-bleed', CardBleed);
}
